import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const items = [
    "FIRST RESPONSE",
    "SATISFACTION GUARANTEED",
    "CHARLESTON SC",
    "SOFT WASH SPECIALISTS",
    "LICENSED & INSURED",
  ];
  return (
    <section className="py-14 sm:py-20 bg-fr-black border-y border-white/10 overflow-hidden" data-testid="marquee-section">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="outline-text font-display font-bold text-5xl sm:text-7xl lg:text-8xl tracking-tighter px-8">
              {t}
            </span>
            <span className="text-fr-blue text-4xl px-8">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
